// 戻るで使うページ状態情報の管理
import { atom } from 'recoil';

/**
 * ヘッダに表示されるページタイトル
 */
export const pageTitle = atom({
  key: 'pageTitle',
  default: {
    pageTitle: '',
  },
});

/**
 * 戻るでページ状態を再現するかのフラグ
 */
export const backPageFlg = atom({
  key: 'backPageFlg',
  default: {
    eqList: false,
    deviceList: false,
    partsList: false,
    deviceMaintList: false,
    deviceTroubleList: false,

    eqMaintList: false,
    eqAchieveList: false,
    eqTroubleList: false,
    eqCsetList: false,
  },
});

/**
 * 設備一覧画面のページ状態
 */
export const eqListPageInfo = atom({
  key: 'eqListPageInfo',
  default: {
    page: 1,
    scrollPosition: 0,
    sortKey: '',
    sortDirection: '',
    serchWord: '',
  },
});

/**
 * 設備機器一覧画面のページ状態
 */
export const deviceListPageInfo = atom({
  key: 'deviceListPageInfo',
  default: {
    page: 1,
    scrollPosition: 0,
    sortKey: '',
    sortDirection: '',
  },
});

/**
 * 機器部品一覧画面のページ状態
 */
export const partsListPageInfo = atom({
  key: 'partsListPageInfo',
  default: {
    page: 1,
    scrollPosition: 0,
    scrollPositionHorizon: 0,
    sortKey: '',
    sortDirection: '',
  },
});

/**
 * 機器点検履歴一覧画面のページ状態
 */
export const deviceMaintListPageInfo = atom({
  key: 'deviceMaintPageInfo',
  default: {
    page: 1,
    scrollPosition: 0,
    sortKey: '',
    sortDirection: '',
  },
});

/**
 * 機器故障履歴一覧画面のページ状態
 */
export const deviceTroubleListPageInfo = atom({
  key: 'deviceTroubleListPageInfo',
  default: {
    page: 1,
    scrollPosition: 0,
    sortKey: '',
    sortDirection: '',
  },
});

/**
 * 設備点検履歴一覧画面のページ状態
 */
export const eqMaintListPageInfo = atom({
  key: 'eqMaintListPageInfo',
  default: {
    page: 1,
    scrollPosition: 0,
    sortKey: '',
    sortDirection: '',
  },
});

/**
 * 設備点検実績一覧画面のページ状態
 */
export const eqAchieveListPageInfo = atom({
  key: 'eqAchieveListPageInfo',
  default: {
    page: 1,
    scrollPosition: 0,
    sortKey: '',
    sortDirection: '',
  },
});

/**
 * 設備故障修理履歴一覧画面のページ状態
 */
export const eqTroubleListPageInfo = atom({
  key: 'eqTroubleListPageInfo',
  default: {
    page: 1,
    scrollPosition: 0,
    sortKey: '',
    sortDirection: '',
  },
});

/**
 * 設備故障修理履歴一覧画面のページ状態
 */
export const eqCsetListPageInfo = atom({
  key: 'eqCsetListPageInfo',
  default: {
    page: 1,
    scrollPosition: 0,
    sortKey: '',
    sortDirection: '',
  },
});
